import type { RouteRecordRaw } from 'vue-router';
import GenericRouterView from '../GenericRouterView.vue';

const setupRoutes: RouteRecordRaw[] = [
  {
    path:  '/setup',
    name:  'setup.index',
    component: GenericRouterView,
    meta: { authRequired: true },
    children: [
      {
        path: 'railroads',
        name: 'setup.railroads.list',
        component: () => import('@/views/setup/railroads/RailroadList.vue'),
        meta: { title: 'Railroads', },
      },

      {
        path: 'car-types',
        name: 'setup.carTypes.list',
        component: () => import('@/views/setup/carTypes/CarTypeList.vue'),
        meta: { title: 'Car Types', },
      },

      // {
      //   path: 'engine-types',
      //   name: 'setup.engineTypes.list',
      //   component: () => import('@/views/setup/railroads/RailroadList.vue'),
      //   meta: { title: 'Engine Types', },
      // },
    ]
  },
];

export default setupRoutes;
